module.exports = __webpack_public_path__ + "media/images/quick-links-arrow-ed97fe6eb678d1c6a1c75419855c05e8.png";